module.exports = __webpack_public_path__ + "media/packs/images/transit/visited-daa6688b72cb0d112e012156fd38f47c.svg";